<template>
  <div class="custom-addon">
    <el-input
      v-model="custom"
      type="textarea"
      :rows="6"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Custom',

  computed: {
    ...mapState(['addons']),
    custom: {
      get () {
        return this.addons.custom
      },
      set (v) {
        this.$store.dispatch('updateCustom', v)
      }
    }
  }
}
</script>

<style lang="scss">

</style>
